import React, { useState } from "react";
import { useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import Sidebar from "../sidebar/Sidebar";
import { Services } from "../../api/Services";
import gymgirl from "../../images/gymgirl.jpg";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import ReactPaginate from "react-paginate";
import Clipboard from "clipboard";
import { BASE_URL_MEDIA } from "../../api/Constants";
import { getImageUrl } from "components/helpers/Helpers";
import VideoPlayerOverlay from "../workout/common/VideoPlayerOverlay";

const ProgrammList = () => {
  const [programms, setProgramms] = useState([]);
  const navigate = useNavigate();
  const isLoggedIn = localStorage.getItem("token");
  const [isLoad, setisLoad] = useState(false);
  const [name, setName] = useState("");
  const [desc, setDesc] = useState("");
  const [isLink, setisLink] = useState(false);
  const [slink, setLink] = useState({});
  const [sinfo, setsInfo] = useState(false);
  const [pageCount, setPageCount] = useState(0);
  const [isLoading, setIsLoading] = useState(false);
  // Video overlay state
  const [isVideoOpen, setIsVideoOpen] = useState(false);
  const [videoUrl, setVideoUrl] = useState("");
  const [videoTitle, setVideoTitle] = useState("Video");

  const openVideo = (programm) => {
    setVideoUrl(programm?.video || "");
    setVideoTitle(programm?.name || "Video");
    setIsVideoOpen(true);
  };

  useEffect(() => {
    if (!isLoggedIn) {
      navigate("/");
    }
    getProgramms(1);
  }, []);
  const showinfo = (name, desc) => {
    setsInfo(true);
    setName(name);
    setDesc(desc);
  };
  //clear localstorage data
  const clearData = () => {
    localStorage.removeItem("cday");
    localStorage.removeItem("cweek");
  };
  //for pagination
  const handlePageClick = (event) => {
    getProgramms(event.selected + 1);
  };

  //create program link

  const createLink = async (id) => {
    setisLoad(true);
    try {
      const result = await Services.createProgramLink(id);
      console.log(result);
      if (result.status === 200) {
        setLink(result?.data);
        setisLink(true);
      } else {
        toast.error(result?.data?.message, {
          autoClose: 2000,
          pauseOnHover: true,
          draggable: true,
          position: toast.POSITION.TOP_CENTER,
        });
      }
      setisLoad(false);
    } catch (error) {
      console.log(error);
    }
  };

  const copyToClipboard = (text) => {
    const clipboard = new Clipboard(".button-sharee", {
      text: () => text,
    });

    clipboard.on("success", (e) => {
      toast.success("Link coppied on clipboard", {
        autoClose: 1500,
        pauseOnHover: true,
        draggable: true,
        position: toast.POSITION.TOP_CENTER,
      });
      console.log("Text copied:", e.text);
      e.clearSelection();
      clipboard.destroy();
    });
    setisLink(false);
    clipboard.on("error", (e) => {
      // You can add an error message here if you'd like
      console.log("Error copying text:", e);
      clipboard.destroy();
    });
  };
  //delete program
  const deleteProgram = async (id) => {
    const confirmed = window.confirm("Do you want to delete this program?");
    if (confirmed) {
      setisLoad(true);
      try {
        const result = await Services.deleteProgramm(id);
        console.log(result);
        if (result.status === 200) {
          toast.success("Program deleted successfully!", {
            autoClose: 1500,
            pauseOnHover: true,
            draggable: true,
            position: toast.POSITION.TOP_CENTER,
          });
          setTimeout(() => {
            getProgramms(1);
          }, 2000);
        } else {
          toast.error(result?.data?.message, {
            autoClose: 2000,
            pauseOnHover: true,
            draggable: true,
            position: toast.POSITION.TOP_CENTER,
          });
        }
        setisLoad(false);
      } catch (error) {
        console.log(error);
      }
    }
  };

  //duplicate program

  const duplicate = async (id) => {
    const confirmed = window.confirm("Do you want to duplicate this program?");
    if (confirmed) {
      setisLoad(true);
      try {
        const result = await Services.duplicateProgram(id);
        console.log(result);
        if (result.status === 200) {
          toast.success("Program duplicated successfully!", {
            autoClose: 1500,
            pauseOnHover: true,
            draggable: true,
            position: toast.POSITION.TOP_CENTER,
          });
          setTimeout(() => {
            getProgramms(1);
          }, 2000);
        } else {
          toast.error(result?.data?.message, {
            autoClose: 2000,
            pauseOnHover: true,
            draggable: true,
            position: toast.POSITION.TOP_CENTER,
          });
        }
        setisLoad(false);
      } catch (error) {
        console.log(error);
      }
    }
  };
  const closeInfo = () => {
    setsInfo(false);
    setName("");
    setDesc("");
  };
  //APi call for program list
  const getProgramms = async (
    page = 1,
    is_for_progress,
    keyword,
    groupid,
    goal,
    weekly,
    monthly
  ) => {
    setIsLoading(true);
    try {
      const result = await Services.getProgrammsList(
        page,
        is_for_progress,
        keyword,
        groupid,
        goal,
        weekly,
        monthly
      );
      console.log(result);
      if (result.status === 200) {
        console.log(result);
        setProgramms(result?.data?.data);
        setPageCount(result?.data?.paging?.total_pages);
      } else {
        toast.error("Some error", {
          autoClose: 2000,
          pauseOnHover: true,
          draggable: true,
          position: toast.POSITION.TOP_CENTER,
        });
      }
      setIsLoading(false);
    } catch (error) {
      console.log(error);
    }
  };

  const excersieCount = (exercises) => {
    const totalExerciseCount = exercises.reduce((total, workout) => {
      return total + workout.exercises.length;
    }, 0);
    return totalExerciseCount;
  };

  const daysCount = (days) => {
    const uniqueDaysArray = [
      ...new Set(days.flatMap((workout) => workout.day.split(","))),
    ];

    // Step 2: Count the number of unique days
    const uniqueDaysCount = uniqueDaysArray.length;
    return uniqueDaysCount;
  };
  return (
    <div className="wrapper-dashboard">
      {isLink && (
        <div className="excercise-modal">
          <div className="add-excersie">
            <fa className="fa fa-times" onClick={() => setisLink(false)}></fa>
          </div>
          <div className="child-modal">
            <h2 className="share-title">{slink?.message}</h2>
            <p id="copyParagraph" className="share-linkk">
              {slink?.data}
            </p>
            <button
              className="button button-sharee"
              onClick={() => copyToClipboard(slink?.data)}
            >
              Copy Link to Clipboard
            </button>
          </div>
        </div>
      )}
      {isLoad && (
        <div className="loaderparent">
          <div className="loader"></div>
        </div>
      )}
      {sinfo && (
        <div className="infoo">
          <div className="header">
            <span className="title">{name}</span>
          </div>
          <div className="desc">
            <span>{desc}</span>
          </div>
          <div className="footer" onClick={() => closeInfo()}>
            Ok
          </div>
        </div>
      )}
      <VideoPlayerOverlay
        isOpen={isVideoOpen}
        onClose={() => setIsVideoOpen(false)}
        url={videoUrl}
        title={videoTitle}
      />
      <ToastContainer />
      <div className="left">
        <Sidebar />
      </div>
      <div className="right">
        <div className="top-title">
          <h2 className="title">My listing</h2>
          <Link to="/create-program" className="button">
            Create a programm
          </Link>
        </div>
        {programms.length > 0 && (
          <div className="row">
            {programms?.map((programm) => (
              <div className="col-12 col-md-4 col-lg-3">
                <div className="programm-wrapper ">
                  <div className="icons">
                    <i
                      className="fa fa-trash"
                      onClick={() => deleteProgram(programm.id)}
                    ></i>
                    <Link to={`/edit-programm/${programm.id}`}>
                      <i
                        className="fa-regular fa-pen-to-square"
                        style={{ color: "green" }}
                        title="Edit programm"
                      ></i>
                    </Link>
                    <i
                      className="fa fa-copy"
                      style={{ color: "rgb(44, 44, 200)" }}
                      onClick={() => duplicate(programm.id)}
                    ></i>
                    {programm?.is_free === 0 && (
                      <i
                        className="fa fa-share"
                        style={{ color: "rgb(44, 44, 200)" }}
                        onClick={() => createLink(programm.id)}
                      ></i>
                    )}
                  </div>
                  <div
                    className="image pointer"
                    onClick={() => {
                      localStorage.setItem("viewType", "list");
                      navigate(`/programmdetail/${programm?.id}`);
                      clearData();
                    }}
                  >
                    {programm?.image !== null ? (
                      <img
                        src={getImageUrl(programm?.image, BASE_URL_MEDIA)}
                      />
                    ) : (
                      <img src={gymgirl} />
                    )}
                  </div>
                  <div className="content">
                    <div className="header_title">
                      <p className="program-name">{programm?.name}</p>
                      <span className="icon">
                        {programm?.video && (
                          <i
                            className="fa fa-video"
                            title="Play video"
                            role="button"
                            onClick={(e) => {
                              e.preventDefault();
                              e.stopPropagation();
                              openVideo(programm);
                            }}
                          ></i>
                        )}
                      </span>
                    </div>
                    <div className="data">
                      {programm?.type === "weekly" ? (
                        <div className="item">
                          <div className="icon">
                            <span>{daysCount(programm?.workouts)}</span>{" "}
                            <i className="fa-regular fa-calendar-days"></i>
                          </div>
                          <div className="value">
                            <span>times a week</span>
                          </div>
                        </div>
                      ) : (
                        <div className="item">
                          <div className="icon">
                            <span>{programm?.number_of_weeks}</span>{" "}
                            <i className="fa-regular fa-calendar-days"></i>
                          </div>
                          <div className="value">
                            <span>Weeks</span>
                          </div>
                        </div>
                      )}
                      <div className="item">
                        <div className="icon">
                          <span>{programm?.workouts?.length}</span>{" "}
                          <i className="fa-solid fa-dumbbell"></i>
                        </div>
                        <div className="value">
                          <span>Workouts</span>
                        </div>
                      </div>
                      <div className="item">
                        <div className="icon">
                          <span>{excersieCount(programm?.workouts)}</span>{" "}
                          <i className="fa-solid fa-dumbbell"></i>
                        </div>
                        <div className="value">
                          <span>exercise</span>
                        </div>
                      </div>
                      <div
                        className="item pointer"
                        onClick={() => showinfo(programm?.name, programm?.desc)}
                      >
                        <div className="icon">
                          <i className="fa-solid fa-eye"></i>
                        </div>
                        <div className="value">
                          <span>View info</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        )}

        {isLoading && (
          <div className="row">
            <div className="col-12 col-md-4 col-lg-3">
              <div className="programm-wrapper">
                <div className="image">
                  <Skeleton height={200} duration={1.5} />
                </div>
                <div className="content">
                  <div className="header_title">
                    <Skeleton height={20} width={120} duration={1.5} />
                    <Skeleton height={20} width={60} duration={1.5} />
                  </div>
                  <Skeleton height={30} duration={1.5} />
                  <div className="data">
                    <div className="item">
                      <Skeleton width={50} height={30} duration={1.5} />
                    </div>
                    <div className="item">
                      <Skeleton width={50} height={30} duration={1.5} />
                    </div>
                    <div className="item">
                      <Skeleton width={50} height={30} duration={1.5} />
                    </div>
                    <div className="item">
                      <Skeleton width={50} height={30} duration={1.5} />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-12 col-md-4 col-lg-3">
              <div className="programm-wrapper">
                <div className="image">
                  <Skeleton height={200} duration={1.5} />
                </div>
                <div className="content">
                  <div className="header_title">
                    <Skeleton height={20} width={120} duration={1.5} />
                    <Skeleton height={20} width={60} duration={1.5} />
                  </div>
                  <Skeleton height={30} duration={1.5} />
                  <div className="data">
                    <div className="item">
                      <Skeleton width={50} height={30} duration={1.5} />
                    </div>
                    <div className="item">
                      <Skeleton width={50} height={30} duration={1.5} />
                    </div>
                    <div className="item">
                      <Skeleton width={50} height={30} duration={1.5} />
                    </div>
                    <div className="item">
                      <Skeleton width={50} height={30} duration={1.5} />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-12 col-md-4 col-lg-3">
              <div className="programm-wrapper">
                <div className="image">
                  <Skeleton height={200} duration={1.5} />
                </div>
                <div className="content">
                  <div className="header_title">
                    <Skeleton height={20} width={120} duration={1.5} />
                    <Skeleton height={20} width={60} duration={1.5} />
                  </div>
                  <Skeleton height={30} duration={1.5} />
                  <div className="data">
                    <div className="item">
                      <Skeleton width={50} height={30} duration={1.5} />
                    </div>
                    <div className="item">
                      <Skeleton width={50} height={30} duration={1.5} />
                    </div>
                    <div className="item">
                      <Skeleton width={50} height={30} duration={1.5} />
                    </div>
                    <div className="item">
                      <Skeleton width={50} height={30} duration={1.5} />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-12 col-md-4 col-lg-3">
              <div className="programm-wrapper">
                <div className="image">
                  <Skeleton height={200} duration={1.5} />
                </div>
                <div className="content">
                  <div className="header_title">
                    <Skeleton height={20} width={120} duration={1.5} />
                    <Skeleton height={20} width={60} duration={1.5} />
                  </div>
                  <Skeleton height={30} duration={1.5} />
                  <div className="data">
                    <div className="item">
                      <Skeleton width={50} height={30} duration={1.5} />
                    </div>
                    <div className="item">
                      <Skeleton width={50} height={30} duration={1.5} />
                    </div>
                    <div className="item">
                      <Skeleton width={50} height={30} duration={1.5} />
                    </div>
                    className="item"
                    <Skeleton width={50} height={30} duration={1.5} />
                  </div>
                </div>
              </div>
            </div>
            <div className="col-12 col-md-4 col-lg-3">
              <div className="programm-wrapper">
                <div className="image">
                  <Skeleton height={200} duration={1.5} />
                </div>
                <div className="content">
                  <div className="header_title">
                    <Skeleton height={20} width={120} duration={1.5} />
                    <Skeleton height={20} width={60} duration={1.5} />
                  </div>
                  <Skeleton height={30} duration={1.5} />
                  <div className="data">
                    <div className="item">
                      <Skeleton width={50} height={30} duration={1.5} />
                    </div>
                    <div className="item">
                      <Skeleton width={50} height={30} duration={1.5} />
                    </div>
                    <div className="item">
                      <Skeleton width={50} height={30} duration={1.5} />
                    </div>
                    <div className="item">
                      <Skeleton width={50} height={30} duration={1.5} />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-12 col-md-4 col-lg-3">
              <div className="programm-wrapper">
                <div className="image">
                  <Skeleton height={200} duration={1.5} />
                </div>
                <div className="content">
                  <div className="header_title">
                    <Skeleton height={20} width={120} duration={1.5} />
                    <Skeleton height={20} width={60} duration={1.5} />
                  </div>
                  <Skeleton height={30} duration={1.5} />
                  <div className="data">
                    <div className="item">
                      <Skeleton width={50} height={30} duration={1.5} />
                    </div>
                    <div className="item">
                      <Skeleton width={50} height={30} duration={1.5} />
                    </div>
                    <div className="item">
                      <Skeleton width={50} height={30} duration={1.5} />
                    </div>
                    <div className="item">
                      <Skeleton width={50} height={30} duration={1.5} />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-12 col-md-4 col-lg-3">
              <div className="programm-wrapper">
                <div className="image">
                  <Skeleton height={200} duration={1.5} />
                </div>
                <div className="content">
                  <div className="header_title">
                    <Skeleton height={20} width={120} duration={1.5} />
                    <Skeleton height={20} width={60} duration={1.5} />
                  </div>
                  <Skeleton height={30} duration={1.5} />
                  <div className="data">
                    <div className="item">
                      <Skeleton width={50} height={30} duration={1.5} />
                    </div>
                    <div className="item">
                      <Skeleton width={50} height={30} duration={1.5} />
                    </div>
                    <div className="item">
                      <Skeleton width={50} height={30} duration={1.5} />
                    </div>
                    className="item"
                    <Skeleton width={50} height={30} duration={1.5} />
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}

        {pageCount > 1 && (
          <div
            style={{ float: "right", marginTop: "20px", marginRight: "10px" }}
          >
            <nav aria-label="Page navigation example">
              <ReactPaginate
                className="pagination pull-right"
                breakLabel="..."
                nextLabel=">"
                onPageChange={handlePageClick}
                pageRangeDisplayed={5}
                pageCount={pageCount}
                previousLabel="< "
                activeClassName="active"
                renderOnZeroPageCount={false}
              />
            </nav>
          </div>
        )}
      </div>
    </div>
  );
};

export default ProgrammList;

// Render the video overlay near the root so it's available globally within this component
// This will utilize fixed positioning and a high z-index
/* Inserted right before component return end */
